$(document).ready(function () {
    // Update variant on swatch click
    $(document).on('click', '.addon-variant', function () {
        var $this = $(this);
        var $product = $this.closest('.product');
        var variantId = $this.data('variant-id');
        var variantImageClass = $this.data('variant-image-class');
        var variantTitle = $this.data('variant-title');
        var variantURL = $this.data('variant-url');

        // change image
        $product.find('.image img:not(.' + variantImageClass + ')').hide();
        $product.find('.image img.' + variantImageClass).show();

        // update the variant to be added to cart
        $product.find('form input[name=id]').attr('value', variantId);

        // update variant title and URL
        $product.data('variant-title', variantTitle);
        $product.find('.image > a, .details > a').attr('href', variantURL);
    });

    // Add upsell accessories to cart for desktop
    $(document).on('submit', '.upsell-accessories-form', function (e) {
        e.preventDefault();
        var $form = $(this);
        var $product = $form.closest('.product');
        var variant = $form.find('input[name=id]').val();
        var productId = $form.find('input[name=product_id]').val();
        var URL = $product.find('.image > a').first().attr('href');
        var image = $product.find('.image img:visible').prop('currentSrc');
        var title = $product.data('product-title');

        var data = {
            productId: productId,
            variant: variant,
            URL: URL,
            image: image,
            title: title
        };

        console.log('Product id from add is:' + productId + '.');

        if ($product.data('variant-title') != 'Default Title') {
            title += ' - ' + $product.data('variant-title');
        }

        $.post('/cart/add.js', {
            id: variant,
            quantity: 1
        }, function (response) {
            $form.closest('.product').addClass('state-added');
            // $form.closest('.product').fadeOut(400, function () {
            //     $form.closest('.product').remove();
            // });

            addUpsellItem($('.accessories-wrapper--desktop'), 8, data);
            addUpsellItem($('.accessories-wrapper--mobile'), 4, data);

            // fetch cart data to update item count and price
            $.ajax({
                dataType: 'jsonp',
                url: '/cart.json?callback=?',
                success: function (cart) {
                    $('.main-product .item-count--number').text(cart.item_count);
                    $('.main-product .price-total').text(Shopify.formatMoney(cart.total_price));
                }
            });
        }, 'json');
    });

    // Remove upsell accessories from cart
    $(document).on('click', '.close', function (e) {
        e.preventDefault();
        var $form = $(this);
        var $product = $form.closest('.accessory-product');
        var variant = $product.data('variant-id');
        var productId = $product.data('product-id');

        // removeUpsellItem($('.accessories-wrapper--desktop'), 8);
        // removeUpsellItem($('.accessories-wrapper--mobile'), 4);

        $.post('/cart/change.js', {
            id: variant,
            quantity: 0
        }, function (response) {
            // remove added to cart flag
            $(".state-added[data-product-id='" + productId + "']").removeClass('state-added');
            // remove product from display
            $product.remove();
            // fetch cart data to update item count and price
            $.ajax({
                dataType: 'jsonp',
                url: '/cart.json?callback=?',
                success: function (cart) {
                    $('.main-product .item-count--number').text(cart.item_count);
                    $('.main-product .price-total').text(Shopify.formatMoney(cart.total_price));
                }
            });
        }, 'json');
    });
});

function addUpsellItem($cartOverview, $itemsLimit, data) {
    var $item = '';
    var $labelWrap = 0;
    var moreCount = 0;

    // check the number of addons in cart-overview
    if ($cartOverview.find('.accessory-product:not(.more-items)').length >= $itemsLimit) {
        // don't add the product, just update the more label
        $labelWrap = $cartOverview.find('.accessory-product.more-items .additional-accessories');
        moreCount = parseInt($labelWrap.data('count'));

        if (moreCount < 0) {
            moreCount = 0;
        }

        moreCount++;

        $labelWrap.data('count', moreCount).text('+ ' + moreCount + ' more');
        $cartOverview.find('.accessory-product.more-items').show();
    } else {
        // create cart overview item
        $item += '<div class="accessory-product" data-variant-id="' + data.variant + '" data-product-id="' + data.productId + '"><a href="#" class="close">x</a><div class="product_image">';
        $item += '<a href="' + data.URL + '">';
        $item += '<img src="' + data.image + '" alt="' + data.title + '">';
        $item += '</a>';
        $item += '</div></div>';

        // add item to cart-overview
        $cartOverview.find('.more-items').before($item);
    }
}

function removeUpsellItem($cartOverview, $itemsLimit) {
    var $labelWrap = 0;
    var moreCount = 0;

    if ($cartOverview.find('.accessory-product:not(.more-items)').length >= $itemsLimit) {
        // don't add the product, just update the more label
        $labelWrap = $cartOverview.find('.accessory-product.more-items .additional-accessories');
        moreCount = parseInt($labelWrap.data('count'));

        if (moreCount < 0) {
            moreCount = 0;
        }
        moreCount--;
        $labelWrap.data('count', moreCount).text('+ ' + moreCount + ' more');

        if (moreCount === 0) {
            $cartOverview.find('.accessory-product.more-items').hide();
        }
    }
}